import apiBackendInstance from '../../../utils/axios';
import BaseUrls from '../../../utils/baseUrls';

export const defaultRequestConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export const getData = async (api_url: string) => {
  let resData;
  await apiBackendInstance.get(`${api_url}`, defaultRequestConfig)
    .then((res) => {
      resData = res.data;
    })
    .catch((err) => {
      resData = err;
    });
  return resData;
};

export const deleteData = async (api_url: string) => {
  let resData;
  await apiBackendInstance
    .delete(`${api_url}`, defaultRequestConfig)
    .then((res) => {
      resData = res.data;
    })
    .catch((err) => {
      resData = err;
    });
  return resData;
};

export const getNetworkDetailData = async (networkId: string | number) => {
  const res = await getData(BaseUrls.getNetworkDetails(networkId));
  return res;
};
export const getAllNodesData = async (networkId: string | number) => {
  const res = await getData(BaseUrls.getAllNodes(networkId));
  return res;
};

export const getNodeCloudData = async (protocolId: string | number) => {
  const res = await getData(BaseUrls.getNodeCloud(protocolId));
  return res;
};

export const getBlockHeightData = async (networkId: string | number, id: string) => {
  const res = await getData(BaseUrls.getNodeInfoUrl(networkId, id));
  return res;
};

export const getRpcDetailData = async (networkId: string, id: string) => {
  const res = await getData(BaseUrls.getRpcDetails(networkId, id));
  return res;
};
